import { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import qs from 'query-string';
import Content from 'src/componentes/pages/content';
import ContentManager from 'src/componentes/content-manager';
import useAuth from 'src/hooks/useAuth';

import View from './View';
import Tabs from 'src/componentes/tabs/tabs';
import Tab from 'src/componentes/tabs/tab';
import RiscoCategorizadoView from './RiscoCategorizado/RiscoCategorizadoView';
import RiscoEditView from 'src/paginas/gestao-risco/risco/RiscoEditView';
import { getConfiguration } from 'src/services/commonRequests';

const Risco = ({ resources: _resources, showModal, ...rest }) => {
  const intl = useIntl();
  const { terms: resources } = useAuth();

  const [idFiltroSalvo, setIdFiltroSalvo] = useState(0);
  const [ehFavorito, setEhFavorito] = useState(false);
  const [tipoFiltro, setTipoFiltro] = useState(null);
  const [configuracao, setConfiguracao] = useState(null);

  useEffect(() => {
    getConfiguration('ItemConfiguracaoRisco')(setConfiguracao)();
  }, []);

  useEffect(() => {
    if (rest.hideHead || showModal) return;

    const id = Number(qs.parse(window.location.search).id);
    if (!id || Number.isNaN(id)) return;

    ContentManager.addContent(<RiscoEditView mode="edit" item={{ id }} />);
  }, []);

  const getFiltroFavorito = (id, favorito, tipo) => {
    setIdFiltroSalvo(id);
    setEhFavorito(favorito);
    setTipoFiltro(tipo);
  };

  return rest.hideHead ? (
    <View
      showCustomFields={true}
      {...rest}
      showModal={showModal}
      configuracao={configuracao}
    />
  ) : (
    <Content
      data-testid="gerenciar-risco-page"
      titulo={intl.formatMessage(
        {
          id: 'riscosMapeados',
        },
        { riscos: resources.riscos }
      )}
      iconSettings={true}
      urlSettings="/configuracoes/risco"
      endPointPermissionSettings="/itemConfiguracaoRisco/PossuiPermissaoConfiguracao"
      iconFavorite={true}
      filtroFavorito={{
        id: idFiltroSalvo,
        ehFavorito: ehFavorito,
        tipoFiltro: tipoFiltro,
      }}
    >
      <Tabs>
        <Tab label={resources.riscos} key={0}>
          <View
            configuracao={configuracao}
            showCustomFields={true}
            {...rest}
            showModal={showModal}
            getFiltroFavorito={getFiltroFavorito}
          />
        </Tab>
        {configuracao?.habilitarDicionarioRiscos && (
          <Tab
            label={intl.formatMessage(
              { id: 'labelDicionarioRiscos' },
              { riscos: resources.riscos }
            )}
            key={1}
          >
            <RiscoCategorizadoView configuracao={configuracao} />
          </Tab>
        )}
      </Tabs>
    </Content>
  );
};

export default Risco;
